import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class ResidentialCleaningGoldCoast extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Residential Cleaning Gold Coast | Professional Home Cleaners"
          description="Residential cleaning Gold Coast. Weekly, fortnightly and deep home cleaning services by experienced professional cleaners."
          keywords="residential cleaning gold coast, house cleaning gold coast, domestic cleaning services gold coast, home cleaning services gold coast, weekly house cleaning gold coast, fortnight cleaning gold coast, regular home cleaners gold coast, deep home cleaning gold coast, spring cleaning gold coast, apartment cleaning gold coast, unit cleaning gold coast, house cleaning surfers paradise, house cleaning broadbeach, house cleaning burleigh heads, house cleaning southport, reliable home cleaners gold coast, affordable house cleaning gold coast, professional house cleaners gold coast, eco friendly home cleaning gold coast, sanitisation cleaning gold coast, bathroom cleaning gold coast, kitchen cleaning gold coast, floor cleaning gold coast, window cleaning gold coast, one off house cleaning gold coast, same day house cleaning gold coast, trusted home cleaning gold coast, cleaning services near me gold coast, relocation house cleaning gold coast, move in house cleaning gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  Residential Cleaning Services Gold Coast
                </h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Residential Cleaning Services Gold Coast
                          </h4>
                          <p>
                            Keeping your home clean and hygienic is essential
                            for comfort and wellbeing. Our residential cleaning
                            Gold Coast service provides reliable and thorough
                            home cleaning tailored to your schedule and
                            requirements. We offer flexible cleaning plans
                            designed for busy households across the region.
                          </p>
                          <div className="dlab-info m-t30">
                            <h4 className="dlab-title m-t0">
                              Weekly and Fortnightly Cleaning
                            </h4>
                            <p>
                              For ongoing maintenance, our regular cleaning
                              services ensure your home remains consistently
                              clean. Includes: Vacuuming carpets, Mopping
                              floors, Dusting all surfaces, Cleaning bathrooms,
                              Wiping kitchen surfaces, and Emptying bins.
                            </p>
                          </div>
                          <div className="dlab-info m-t30">
                            <h4 className="dlab-title m-t0">
                              Deep Cleaning & Spring Cleaning
                            </h4>
                            <p>
                              Our deep cleaning service is ideal for seasonal
                              refreshes, long-overdue maintenance, or preparing
                              for special guests. We cover areas often
                              overlooked during routine cleans, such as
                              stovetops, cabinet exteriors, skirting boards, and
                              window tracks.
                            </p>
                          </div>
                          <div className="dlab-info m-t30">
                            <h4 className="dlab-title m-t0">
                              Eco-Friendly Cleaning Products
                            </h4>
                            <p>
                              We use eco-friendly cleaning solutions that are
                              safe for families, children, and pets, without
                              compromising on cleaning power.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default ResidentialCleaningGoldCoast;
